import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";

const CompanyAddress = (props) => {
  const { t, data, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive === 1 ? 1 : "0.2"}>
        <div>
          {data.street ? data.street : ""}
          {!!data.street && <br />}
          {parseInt(data.country, 10) === 1 && (
            <>
              {data.city ? " " + data.city : ""}
              {data.postalCode ? ", " + data.postalCode : ""}
            </>
          )}
          {parseInt(data.country, 10) !== 1 && (
            <>
              {data.postalCode ? " " + data.postalCode : ""}
              {data.city ? ", " + data.city : ""}
            </>
          )}
        </div>
      </DivBackgroundOpacity>
    </>
  );
};

CompanyAddress.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyAddress);
